module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "_idContainer014",
      "role": "doc-chapter"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("R")]), _vm._v("yan stared at the yellow crime scene tape stretched around their house, watching it quiver in the morning breeze.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His phone was pressed to his ear. He was on hold with a tech supervisor with his service provider, attempting to locate Maddie’s phone. The hold music was Glen Campbell’s “Rhinestone Cowboy,” and Ryan had heard most of it when the supervisor came back on the line.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry, sir, we’re unable to locate the phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t understand. I’ve got map locater and phone finder features for all of our phones—we’re damn well paying for them!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sir, I understand your situation, but for those features to work, a phone must be on a data network and right now your daughter’s does not have a connection, and that could be for any number of reasons. We’ll keep working on things here.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What about giving us the numbers or names of the people she last communicated with?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A long silence passed between them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hello? Are you there?” Ryan said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sir, we can’t provide that information due to privacy restrictions.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What? Our daughter is a minor—she’s missing, and your priority is to protect the people who may know where she is?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry, sir, my hands are tied.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Un-freaking-believable!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Again, my apologies, perhaps you could work with police and—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ryan hung up and dragged his hand over his face, his heart sinking with every passing second.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A few hours ago they were living their lives, doing the best they could like any other family before their world was ripped apart.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This can’t be happening! Maddie can’t be gone!")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But each moment that passed made it more real. Ryan’s stomach tightened as if clamped in the jaws of a bench vise, and questions burned through his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Who could’ve taken her? Why Maddie?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("For an instant he considered Crystal and her boyfriend, Zach. Ryan didn’t know Zach’s last name but had seen him a few times, most recently when he and Karen had bumped into them at the mall. He recalled Zach had a lot of tattoos and piercings, earrings, eyebrow ring, lip loops and a nose stud, and that he had trouble making eye contact when you spoke to him. Ryan got a bad vibe from the guy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And I can’t shake the feeling Crystal snuck him into the house last night against our rules. But the kids were in bed after Crystal left with him. Maybe Zach came back? Maybe he got the ladder and—")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ryan stopped himself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I can’t point fingers at people with no proof. Wait. Wrong. I sure as hell can! Our little girl’s gone. They should question that tattooed little—Stop, think. We’ve gotta search for her. I know who I should call but—")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("More people had converged on their home.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jeff and Jean Cooper, their neighbors who’d briefly watched over Tyler, were among the first.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’re here to help,” said Jeff, a retired firefighter.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then a dog barked, and Ryan’s thoughts shifted as he, Karen and Officer Porter were joined by Officer DeDe Cook and her partner, Hitch, a male Belgian shepherd dog.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ll need something your daughter wore or kept close to her,” Cook said, stroking Hitch, who was panting as she fixed a tracking line to his collar.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Porter was still wearing latex gloves. She reentered the house and returned with Maddie’s pillowcase. Cook ran it under Hitch’s nose. He yipped, acknowledging he’d registered Maddie’s scent, then led Cook to the back of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Hitch kept his snout to the ground under Maddie’s window. His tail wagging as he worked, the dog soon pulled his partner across the yard until they disappeared into the dense woods of Lucifer’s Green.")]), _vm._v(" "), _c('hr', {
    staticClass: "tb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_vm._v("As Karen watched the police dog pursue a trail into the woods, a measure of hope rippled in her heart.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maybe Maddie called a friend and ran off because she’s mad at me? Maybe it’s a stunt and they’re hiding in there?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Karen turned to Porter, standing beside her and Tyler on the street at a spot from where they saw the K-9 team disappear among the trees. Ryan had stepped away to talk to Greer and other arriving officers.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The dog’s picked up Maddie’s scent, right?” Karen said. “We should run after them and help search.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ll let them work alone first. We’re setting things up for a search here now, and we’ve put the advisory out.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“See, Mom?” Tyler showed her his phone. “It’s posted everywhere online.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Maddie smiled back at Karen from the notice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-sb"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Missing Person—Possible Abduction")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-tab-sa"
  }, [_vm._v("Maddison Lane. Age: 12 years old. Gender: Female. Height: 4’ 11\". Weight: 87 lbs. Hair: Brown. Eyes: Brown. Scars/Marks: Half-moon shaped birthmark above right ankle, Clothes/Wearing: Pajamas, two piece, black long-sleeved top w/ matching pants. Top has multicolored hearts spelling “Time To Chill.” Pants have matching hearts pattern. Also wearing yellow hoodie and white sneakers with pink polka-dot laces. In possession of a pink cell phone with a glitter butterfly pattern case with name “Maddie.” From: Syracuse, NY USA. Anyone with information please call your local police.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Karen stared hard at her daughter’s face, at her pretty smile, at how her eyes sparkled as she crushed Ice Baby to her. Here she was just yesterday, your average twelve-year-old girl before she’d tried to convince Karen, yet again, that she was on the cusp of womanhood and should be able to bring boys home.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Not on your life, young lady. Not till you’re older. That’s what I told her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Emotions surged in Karen, and she covered her mouth with her hand. Then her phone rang. It was Lauren Webb, the mother of Maddie’s friend Nicole.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Karen, I was in the shower when I got your message! Oh my God, is Maddie really missing?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes! Did she go to your house? Does Nicole know anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, Maddie’s not here. Hang on, I’ll get Nicole.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Mom.” Tyler had been texting friends nonstop since Ryan had called police. “I asked Nicole already. I’m asking everybody, and so far nobody knows anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A few seconds passed and Lauren came back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, Karen, we don’t know anything. What happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We think someone took her from her bedroom last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh my God!” Lauren shouted to someone in her house then came back to Karen. “Where are you? Are you home?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes, with the police. They’ve got a dog looking for her in the woods.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay, we’re coming over to help.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Karen ended the call and her phone rang again. This time it was Valerie Morber, the mother of Maddie’s friend Amanda.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Karen, I just heard from Amanda. She’s been talking to friends asking around about Maddie. Are you home? We want to help.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As word spread, Karen received more calls, then suddenly she and Tyler were hugged by Mary Ling and Sarah Ramirez, her coworkers.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We came as soon as we heard from Bill at the store,” Sarah said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“More people are coming,” Mary said. “Sidra and Latonya are at the copy shop. They’re downloading the missing notice to make posters. We’ll put them up everywhere in the neighborhood. We’ll do whatever it takes to find her.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Karen thanked them and through her tears she now counted six police cars parked on the street in front of their house. Ryan was nearby huddled with police officers, neighbors and people Karen didn’t recognize.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I hope he called his brother. Maddie’s life is at stake. We need help.")])]), _vm._v(" "), _c('hr', {
    staticClass: "tb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_vm._v("“You’re not listening to me Officer Greer.” Ryan struggled to keep himself together. “You have to work with our carrier to track Maddie’s phone, find out who she talked to last. And you’ve got to talk to our babysitter, Crystal Hedrick. I’m certain she had her boyfriend over here last night, and I don’t trust that guy. He may have come back. His name is Zach somebody. Why aren’t you questioning him? We’re losing time here!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Police radios crackled.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The eyes of the officers who encircled Ryan went to him, then to Greer. Greer reached for the microphone clipped to his shoulder, confirmed a message to his dispatcher, then nodded to Ryan.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Mr. Lane, we’re bringing in more expertise and resources to help us on all fronts.” Greer was calm, respectful. “And I can assure you, we’ve sent officers to Crystal Hedrick’s residence to obtain a statement from her.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What about Zach?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ll confirm his whereabouts as part of the investigation.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay, that’s good.” Ryan indicated the woods behind their house. “Did the dog pick up anything yet? Shouldn’t you have more people in there?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We have to let the K-9 team do their work first. We’re requesting the county’s helicopter, and we’ll get drones up.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ryan was nodding as Greer continued.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ve circulated our missing person alert online for Maddison, we’re about to launch a canvass here and we’re preparing to issue an Amber Alert.” Greer raised his chin beyond the half-dozen officers. “Excuse me, and you are?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Chuck Field,” the first man said. “This is Red Baldwin and Phil Demarco. We work with Ryan.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ryan was happy to see them. Chuck was his right-hand man.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We came as soon as we could. We’re here to help,” Chuck said. “And don’t worry about the job we’re on, or the business. We’ll help you here and take care of work, so don’t worry.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ryan nodded his thanks, then Greer’s attention shifted to the five other men from the neighborhood who’d joined the group. Two stepped forward to make introductions. The first was Ryan’s neighbor Judd Salter, a retired armored car driver who headed the local neighborhood crime watch group. The other man, Angelo Darnado, who Ryan didn’t know, was from the neighborhood association. Salter and Darnado identified the others as members of neighborhood groups.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Ryan, we just heard and our prayers are with you and Karen.” Salter gripped Ryan’s shoulder then turned to Greer. “Sir, we’ve been alerted about Maddison’s disappearance and we’re standing by to activate our call out and help.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank you. Here’s what’s going to happen,” Greer said. “Our people will knock on doors in a canvass and check for residential security cameras. Mr. Salter, can you get your people to get neighbors in the surrounding area to check their property for anything that might help. Do you have forms?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We do.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right, all of this must be logged and recorded with names, times, dates and turned over to us. Remember to show your crime watch identification.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ll get on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And what about the other side of the Green?” one of the officers asked Greer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Something in the officer’s tone betrayed to Ryan that a secret exchange of information had passed between the officers, something important.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah,” Greer said. “We’ll get our people to start a canvass along DeBerry Street and the others that border the woods.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hold on. Isn’t that where the new halfway house for paroled criminals is supposed to open next month? On DeBerry?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s been operating for about six months now,” Greer said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Six months?")]), _vm._v(" What the—Six months? Why didn’t we know?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It opened quietly. They wanted it low profile. Mr. Lane, take it easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Take it easy?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Those residences are monitored under tight restrictions. This will be a matter of routine that we’ll check everyone, everywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ryan bit his bottom lip, angry at himself for not thinking, not remembering about the halfway house and not putting up a better fence and security. How could he let his guard down? His mind had been focused on his business.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("More people had arrived from Karen’s store and were gathered around her, comforting her and Tyler.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The nightmare’s real")]), _vm._v(", Ryan thought as he stood there, helpless amid the chaos of the growing search, stubbled face, hair messed, still wearing a T-shirt and sweatpants, although he’d managed to get sneakers on his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Time is ticking down on Maddie, and we need more help")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Feeling his phone in his hand, he made the call he had to make and it was answered on the third ring.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s me,” Ryan said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey bro, what’s up?” Cole Lane said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("So positive. That can-do, climb-any-mountain drive of his just floods through—I don’t know if I can say it. How do I say it?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The silence hissed until Cole broke it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What is it, Ry? Why’re you calling?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maddie’s gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What? What do you mean, Maddie’s gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ryan took a breath and slowly relayed all he knew to his older brother.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ve got police but we need your help, Cole.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay. Who’s there from the Syracuse police leading things at the moment?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Officers Dalvin Greer and Eve Porter.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t know them. Did they protect the scene, seal the house?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right, I’ll call some of my guys. I’ll get Jill and Dalton and we’ll be right over. Hang in there. It’s going to be fine, okay? You hang in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hang in there")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ending the call and taking stock of everything around him, Ryan thought it was ironic because “hang in there,” were the words he and Karen had used all those years ago to help save Cole’s life.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e301476","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/5.vue
// module id = 96
// module chunks = 0